import { AnyAction } from 'redux'

export interface IMemberGetMemberState {
  name: string
  code: string
  show: boolean
}

export const initialState: IMemberGetMemberState = {
  name: '',
  code: '',
  show: false,
}

export const SET_MEMBER_GET_MEMBER_STATE = 'SET_MEMBER_GET_MEMBER_STATE'
export const SET_MEMBER_GET_MEMBER_CODE = 'SET_MEMBER_GET_MEMBER_CODE'
export const HIDE_MEMBER_GET_MEMBER = 'HIDE_MEMBER_GET_MEMBER'

export function setMemberState(name: string, show: boolean) {
  return {
    type: SET_MEMBER_GET_MEMBER_STATE,
    name,
    show,
  }
}

export function setMemberCode(code: string) {
  return {
    type: SET_MEMBER_GET_MEMBER_CODE,
    code,
  }
}

export function hideMember() {
  return {
    type: HIDE_MEMBER_GET_MEMBER,
  }
}

export function memberGetMemberReducer(
  state = initialState,
  action: AnyAction,
) {
  switch (action.type) {
    case SET_MEMBER_GET_MEMBER_STATE:
      return {
        ...state,
        name: action.name,
        show: action.show,
      }
    case SET_MEMBER_GET_MEMBER_CODE:
      return {
        ...state,
        code: action.code,
      }
    case HIDE_MEMBER_GET_MEMBER:
      return {
        ...state,
        show: false,
      }
    default:
      return state
  }
}
